//#region Asset Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { IUserSession, UserSession } from '../../helpers/user-session'
import { Activity } from '../../models/common/activity'
import { default as commonModule, LoggerService } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ScriptsController } from './scripts.controller'

//#region Aseet Imports

import './scripts.scss'
import * as TEMPLATE from './scripts.tpl.html'

//#endregion

var moduleName = 'simax.scripts'
var module = angular.module(moduleName, [commonModule, apiModule])

module.controller('ScriptsController', [
    '$scope',
    '$state',
    '$timeout',
    '$q',
    'api',
    'logger',
    'localDictionary',
    'userSession',
    ($scope, $state: StateService, $timeout, $q, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) =>
        new ScriptsController($scope, $state, $timeout, $q, api, logger, localDictionary, userSession)])

module.config(["$stateProvider", 'userSessionProvider', ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider.getLoggedOperatorAsync().then(loggedOperator => {
        if (loggedOperator.hasPermission(Activity.WEBSIMAX_CUSTOM_SCRIPT_RUN_OP)) {
            MenuItem.addMenuItem(window['config']['ICONS']['SCRIPTS'], 'scripts', 'Scripts', 'scripts', 17)
            $stateProvider.state('scripts', {
                url: '/scripts',
                controller: 'ScriptsController',
                template: TEMPLATE,
            })
        }
    })
}])

export default moduleName